import React from 'react';
import { useTranslation } from "react-i18next";

function MarkakolSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("markakol.title", "Markakol Lake")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "markakol.intro",
                    "Markakol Lake, located in the East Kazakhstan Region within the Altai Mountains, is one of the country’s most pristine high-altitude lakes. Surrounded by taiga forests and alpine meadows, it is celebrated for its unspoiled nature and biodiversity."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("markakol.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("markakol.highlight1", "A high-altitude lake with crystal-clear waters at over 1,400 meters above sea level.")}</li>
                <li>{t("markakol.highlight2", "Rich wildlife, including sable, moose, and many bird species.")}</li>
                <li>{t("markakol.highlight3", "Surrounding taiga forests of larch, cedar, and birch creating a unique atmosphere.")}</li>
                <li>{t("markakol.highlight4", "Traditional villages nearby preserving local Kazakh and Altai culture.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "markakol.conclusion",
                    "Markakol is a hidden jewel of Kazakhstan’s eastern mountains, offering tranquility, breathtaking nature, and cultural authenticity far from crowded tourist routes."
                )}
            </p>
        </div>
    );
}

export default MarkakolSightPage;
